import { Component, OnInit } from '@angular/core';
import { faExclamationTriangle, faSquare } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss']
})
export class ForbiddenComponent implements OnInit { 

  faWarring = faExclamationTriangle;
  faSquare = faSquare;

  constructor() { }

  ngOnInit(): void {
  }
}
